import PropTypes from 'prop-types';
import React from 'react';
import { VelocityComponent } from 'velocity-react';
export default function ProgressBar(_a) {
    var noOfSteps = _a.noOfSteps, completedStep = _a.completedStep, _b = _a.initialProgress, initialProgress = _b === void 0 ? 0 : _b, children = _a.children, _c = _a.duration, duration = _c === void 0 ? 300 : _c, onAnimationComplete = _a.onAnimationComplete;
    var animation = getAnimation(initialProgress, noOfSteps, completedStep);
    return (React.createElement(VelocityComponent, { animation: animation, complete: onAnimationComplete, duration: duration, runOnMount: true }, children));
}
ProgressBar.propTypes = {
    noOfSteps: PropTypes.number.isRequired,
    completedStep: PropTypes.number.isRequired,
    initialProgress: PropTypes.number,
    children: PropTypes.node.isRequired,
    duration: PropTypes.number,
    onAnimationComplete: PropTypes.func,
};
function getAnimation(initialProgress, noOfSteps, completedStep) {
    var currentProgress = getProgressForCompletedStep(noOfSteps, initialProgress, completedStep);
    var previousProgress;
    if (completedStep === 0) {
        previousProgress = 0;
    }
    else {
        previousProgress = getProgressForCompletedStep(noOfSteps, initialProgress, completedStep - 1);
    }
    var animation = {
        width: [toPct(currentProgress), 'ease-in-out', toPct(previousProgress)],
    };
    if (completedStep === noOfSteps) {
        animation.opacity = [0, 'ease-in-out', 1];
    }
    return animation;
}
function getProgressForCompletedStep(noOfSteps, initialProgress, completedStep) {
    return completedStep * ((1 - initialProgress) / noOfSteps) + initialProgress;
}
function toPct(value) {
    return "".concat(Math.round(value * 100), "%");
}
